export default "https://assets.egbcdn.net/assets/packs/_/videos/lootbox/video-dota-8517684d4abbe9a5515270143b2e5631.webm";